var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5C0 0.670312 0.670312 0 1.5 0H19.5C20.3297 0 21 0.670312 21 1.5C21 2.32969 20.3297 3 19.5 3H1.5C0.670312 3 0 2.32969 0 1.5ZM0 9C0 8.17031 0.670312 7.5 1.5 7.5H19.5C20.3297 7.5 21 8.17031 21 9C21 9.82969 20.3297 10.5 19.5 10.5H1.5C0.670312 10.5 0 9.82969 0 9ZM21 16.5C21 17.3297 20.3297 18 19.5 18H1.5C0.670312 18 0 17.3297 0 16.5C0 15.6703 0.670312 15 1.5 15H19.5C20.3297 15 21 15.6703 21 16.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.111f9c08154460dce7115de60af429c8.svg";
export { ForwardRef as ReactComponent };